import React from 'react'
import styled from 'styled-components'

import Background from './Background'
import Foreground from './Foreground'

const Outer = styled.div`
  position: relative;
  height: calc((180 / 1565) * 100vw);
  min-height: 115px;

  svg {
    position: absolute;
    left: 0;
    top: auto;
    bottom: 0;
    min-width: 1000px;
    width: 100%;
  }

  &:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -4px;
    height: 8px;
    background-color: ${({ theme }) => theme.brand.jungle};
  }
`

const Horizon = () => {
  return (
    <Outer>
      <Background className="footer-background" />
      <Foreground className="footer-foreground" />
    </Outer>
  )
}

export default Horizon
